// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-facet .option[data-v-bcfbf0fa]{display:flex;align-items:center;margin:1em 0}.checkbox-facet .option .count[data-v-bcfbf0fa]{margin-left:.2em}.checkbox-facet .option .text[data-v-bcfbf0fa]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.checkbox-facet .option .checkbox-indicator[data-v-bcfbf0fa]{top:0}.checkbox-facet .show-more-btn[data-v-bcfbf0fa]{background:none;border:none;outline:none;padding:0;color:#7a7a7a;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
